import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateRangePickerComponent } from './date-range-picker.component';

@NgModule({
	declarations: [],
	imports: [DateRangePickerComponent],
	exports: [DateRangePickerComponent],
})
export class DateRangePickerModule {}
